import {createSelector} from '@ngrx/store';
import {AppState} from '../app-state';
import {Alert} from '../../../core/model/alert';

export const selectAlertsState = (state: AppState) => state.alerts;

export const selectAllAlerts = createSelector(selectAlertsState, state => state.alerts);

export const selectAlertsMap = createSelector(selectAllAlerts, alerts =>
  alerts.reduce((alertsMap: Record<string, Alert>, obj: Alert) => ((alertsMap[obj._id] = obj), alertsMap), {})
);

export const selectUnreadAlertsCount = createSelector(selectAlertsState, state => state.unreadAlertsCount);
